module.exports = __webpack_public_path__ + "img/等级回升.5987b19f.png";